import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlowMeterMetricsComponent } from './flow-meter-metrics.component';
import {DxChartModule, DxDataGridModule, DxPivotGridModule, DxScrollViewModule, DxSelectBoxModule} from 'devextreme-angular';
import {DxoValueAxisModule} from 'devextreme-angular/ui/nested';
import {GridTitleModule} from 'shared';



@NgModule({
  declarations: [FlowMeterMetricsComponent],
  imports: [
    CommonModule,
    DxChartModule,
    DxoValueAxisModule,
    DxScrollViewModule,
    DxPivotGridModule,
    DxSelectBoxModule,
    GridTitleModule,
    DxDataGridModule
  ],
  exports: [FlowMeterMetricsComponent]
})
export class FlowMeterMetricsModule { }
